var file_upload_viewer_default = {
  "fontElementMap": "clHER",
  "file_upload_container": "WQ73x",
  "file_upload_link": "_8zMkH",
  "file_upload_error_container": "_-2RAP",
  "file_upload_file_info": "xBzTU",
  "file_upload_type_icon": "IyfAX",
  "file_upload_status_icon_container": "LVPrA",
  "file_upload_status_icon": "Uy0P9",
  "file_upload_description": "n3UrO",
  "file_upload_name_container": "H0l8u",
  "file_upload_name": "TNnuI",
  "file_upload_extension": "vY4qx",
  "file_loader_icon": "fVcTK",
  "file_upload_icon_frame": "d3KqS",
  "file_upload_icon_background": "_-5lb0"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
